(function () {
  function format(distance) {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((distance / (1000 * 60)) % 60);
    const seconds = Math.floor((distance / 1000) % 60);

    return (
      `${String(days).padStart(2, '0')}d ` +
      `${String(hours).padStart(2, '0')}:` +
      `${String(minutes).padStart(2, '0')}:` +
      `${String(seconds).padStart(2, '0')}`
    );
  }

  function onCountdownEnd(timerEl) {
    const container = timerEl.closest('.countdownContainer');

    container?.classList.add('countdownContainer--ended');
    document.dispatchEvent(new CustomEvent('promotion:ended'));
  }

  function updateOne(timerEl) {
    const promotionDate = timerEl.getAttribute('data-date-promotion');
    if (!promotionDate) return;

    const endDate = new Date(promotionDate).getTime();
    if (Number.isNaN(endDate)) return;

    const now = Date.now();
    const distance = endDate - now;

    if (distance <= 0) {
      timerEl.textContent = '00d 00:00:00';
      if (!timerEl.dataset.ended) {
        timerEl.dataset.ended = 'true';
        onCountdownEnd(timerEl);
      }
      return;
    }

    timerEl.textContent = format(distance);
  }

  function tick() {
    const timers = document.querySelectorAll('.countdown-timer[data-date-promotion]');

    timers.forEach(updateOne);
  }

  tick();
  setInterval(tick, 1000);

  const root = document.getElementById('pdp-promo-countdown');
  if (!root) return;

  const timer = root.querySelector('.pdp-promo-countdown__timer');
  if (!timer) return;

  const raw = (timer.getAttribute('data-promo-date') || '').trim();
  if (!raw) return;

  function parseEndMs(str) {
    // 1) tenta direto (funciona bem com ISO)
    let ms = Date.parse(str);
    if (!Number.isNaN(ms)) return ms;

    // 2) se vier "YYYY-MM-DD" (sem hora), assume fim do dia
    // evita timezone bug jogando uma hora fixa
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
      ms = Date.parse(str + 'T23:59:59');
      if (!Number.isNaN(ms)) return ms;
    }

    // 3) se vier "DD/MM/YYYY" ou "DD/MM/YYYY HH:mm:ss"
    const m = str.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
    if (m) {
      const dd = +m[1], mm = +m[2] - 1, yyyy = +m[3];
      const HH = +(m[4] || 23), MI = +(m[5] || 59), SS = +(m[6] || 59);
      return new Date(yyyy, mm, dd, HH, MI, SS).getTime();
    }

    return NaN;
  }

  const endMs = parseEndMs(raw);
  if (Number.isNaN(endMs)) {
    // só pra você ver que não parseou
    // (se quiser, pode remover)
    timer.textContent = '--';
    return;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  let pdpIntervalId;

  function render() {
    const diff = endMs - Date.now();

    if (diff <= 0) {
      timer.textContent = '00d 00:00:00';
      root.style.display = 'none'; // some o bloco
      if (pdpIntervalId) clearInterval(pdpIntervalId);
      return;
    }

    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    timer.textContent = `${pad(d)}d ${pad(h)}:${pad(m)}:${pad(s)}`;
  }

  render();
  pdpIntervalId = setInterval(render, 1000);
})();
